export default "__VITE_ASSET__D9T8G3SA__"